<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>
<div class="container-header"><div class="container-header-inner">
  @if (isLoading) { <app-loading-box></app-loading-box> }
  @else if (documento) {
    <app-nfe-detalhe [notaDetalhe]="documento" [idDFeRecebido]="idNFeRecebido"
      [origemDocumentoFiscalRecebido]="origemDocumentoFiscalRecebido"
      (refreshData)="carregarDados()"></app-nfe-detalhe>
  } @else { <h1 class="title-default">NF-e recebida não encontrada</h1> }
</div></div>
